import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import PlanningPage from './components/PlanningPage/PlanningPage'
import * as serviceWorker from './serviceWorker';
import InfoPopUp from './components/PopUp/InfoPopUp';

ReactDOM.render(
  <React.StrictMode>
      <div>
          <PlanningPage />
      </div>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
